import { Button, Col, Row } from 'antd';
import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useContext } from "react";
import { AuthenticationContext } from "../../App";

const ViewAA = ({ pdfurl }) => {
    const navigate = useNavigate();
    const applicationId = localStorage.getItem('applicationId');
    const agentId = localStorage.getItem('agentId');
    const { authData } = useContext(AuthenticationContext);
    return (
        <div className="w-full min-h-screen bg-[#F5F5F5] overflow-x-clip">
            <div className="bg-white">
                <Row gutter={[24, 24]} className='p-[18px_25px]'>
                    <Col xs={24} sm={12} md={24} lg={24}>
                        <div className="text-[18px] font-[700] bg-white flex">
                            <div className="mt-1 min-[768px]: mr-5 max-[768px]:mr-1 cursor-pointer" onClick={() => navigate(-1)}>
                                <img src="/images/left-circle.svg" alt="arrow" />
                            </div>
                            <p>Loan Application</p>
                        </div>
                    </Col>
                </Row >
            </div >
            <div className='min-[768px]:mx-[50px]'>
                <iframe src={"https://api.ohhto.com/v1/agent/application/approval/advice/" + applicationId + "/" + authData.id + "/b893461f-8621-43a1-b6a2-688482a98c73"} className='aa-height' id='pdf' title="PDF Viewer" width="100%" height="100%" />
            </div>
        </div>
    );
};

export default ViewAA;